export const featureFlags = {
  custom_scoring_experimental: { id: 'custom_scoring_experimental', description: 'Custom Scoring', enabled: false },
};
